import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const _GetTurnoversRequestDtoSchema = z.object({
  from: z.string(),
  to: z.string(),
  facilitiesIds: z.array(z.number()).optional(),
});

const GetTurnoversResponseDtoSchema = z.object({
  count: z.number(),
  changePct: z.number().nullable(),
});

export type GetTurnoversRequestDto = z.infer<
  typeof _GetTurnoversRequestDtoSchema
>;
export type GetTurnoversResponseDto = z.infer<
  typeof GetTurnoversResponseDtoSchema
>;

export const getTurnovers = (
  params: GetTurnoversRequestDto,
  config?: AxiosRequestConfig<GetTurnoversRequestDto>
) => {
  return api
    .get('/staff/turnovers', { params, ...config })
    .then(responseContract(GetTurnoversResponseDtoSchema));
};
